import React, {useEffect, useReducer} from "react";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";
import {PrintStoreReconciliationSheetReducer} from "./reducers/PrintStoreReconciliationSheetReducer";

const initialState = {
    isSuccess: true
};

export const StoreReconciliationSheetResponse = ({checkedDrivers}) => {
    const [{isSuccess}, casDispatch] = useReducer(PrintStoreReconciliationSheetReducer, initialState);

    useEffect(() => {
        casDispatch({
            type: "PRINT_STORE_RECONCILIATION_SHEET",
            data: {
                driversList: checkedDrivers,
                dispatcher: casDispatch
            }
        })
    }, []);

    if (!isSuccess) {
        return (
            <Row alignmentHorizontal="center" alignmentVertical="center">
                <Alert type="error">Error</Alert>
            </Row>
        );
    }
    return (<Box></Box>
    );
};


// WEBPACK FOOTER //
// ./src/components/storeReconciliationSheet/StoreReconciliationSheetResponse.js